// Libs
import { useEffect } from 'react';

// RDS
import Button from '@ramsey-design-system/button';

// Components
import Dialog from '~fpu/shared/components/Dialog';

// Hooks
import { useMixpanelEvent } from '~fpu/shared/hooks/useMixpanelEvent';

// Utils
import { formatMaxWorkshopDate, MAX_WORKSHOP_WEEKS_AHEAD } from './constants';

function RestrictedDateDialog({
  open,
  onDismiss,
  restrictedDate
}: {
  open: boolean;
  onDismiss: () => void;
  restrictedDate: string;
}) {
  const { mutate: trackMixpanelEvent } = useMixpanelEvent();

  useEffect(() => {
    if (!open) return;

    trackMixpanelEvent({
      event: 'Element Viewed',
      properties: {
        element: 'Budget Workshop Restricted Date Dialog',
        label: restrictedDate
      }
    });
  }, [open, restrictedDate, trackMixpanelEvent]);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div onClick={(event) => event.stopPropagation()}>
      <Dialog open={open} onClose={onDismiss} width="sm">
        <Dialog.Title className="mb-4" level="2">
          Scheduling is limited during beta
        </Dialog.Title>

        <Dialog.Description className="mb-4">
          {`While Budget Workshop is in beta, you can only schedule a workshop on or before ${formatMaxWorkshopDate()} (${MAX_WORKSHOP_WEEKS_AHEAD} weeks from today). Pick a date in that range, and check back later as we expand scheduling further out.`}
        </Dialog.Description>

        <Button
          data-testid="restricted-date-dismiss-button"
          fullWidthOnMobile
          onClick={onDismiss}
        >
          Got it
        </Button>
      </Dialog>
    </div>
  );
}

export default RestrictedDateDialog;
